/** Abre wa.me na mesma janela — no mobile abre o app; _blank costuma ir para Web/loja. */
export function openWhatsApp(href: string): void {
  if (!href) return
  window.location.assign(href)
}
